/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { Configuration } from '../configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiLanguagesGet } from '../fn/languages/api-languages-get';
import { ApiLanguagesGet$Params } from '../fn/languages/api-languages-get';
import { apiLanguagesLanguageLocalesGet } from '../fn/languages/api-languages-language-locales-get';
import { ApiLanguagesLanguageLocalesGet$Params } from '../fn/languages/api-languages-language-locales-get';
import { apiLanguagesLanguageLocalesIdGet } from '../fn/languages/api-languages-language-locales-id-get';
import { ApiLanguagesLanguageLocalesIdGet$Params } from '../fn/languages/api-languages-language-locales-id-get';
import { apiLanguagesLocalesGet } from '../fn/languages/api-languages-locales-get';
import { ApiLanguagesLocalesGet$Params } from '../fn/languages/api-languages-locales-get';
import { GetLanguageLocalesResult } from '../models/get-language-locales-result';
import { GetLanguagesResult } from '../models/get-languages-result';
import { GetLocalesResult } from '../models/get-locales-result';
import { LanguageLocaleDto } from '../models/language-locale-dto';


/**
 * Languages and locales
 */
@Injectable({ providedIn: 'root' })
export class LanguagesService extends BaseService {
  constructor(config: Configuration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiLanguagesGet()` */
  static readonly ApiLanguagesGetPath = '/api/Languages';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLanguagesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLanguagesGet$Response(params?: ApiLanguagesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetLanguagesResult>> {
    const obs = apiLanguagesGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLanguagesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLanguagesGet(params?: ApiLanguagesGet$Params, context?: HttpContext): Observable<GetLanguagesResult> {
    const resp = this.apiLanguagesGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetLanguagesResult>): GetLanguagesResult => r.body)
    );
  }

  /** Path part for operation `apiLanguagesLocalesGet()` */
  static readonly ApiLanguagesLocalesGetPath = '/api/Languages/locales';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLanguagesLocalesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLanguagesLocalesGet$Response(params?: ApiLanguagesLocalesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetLocalesResult>> {
    const obs = apiLanguagesLocalesGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLanguagesLocalesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLanguagesLocalesGet(params?: ApiLanguagesLocalesGet$Params, context?: HttpContext): Observable<GetLocalesResult> {
    const resp = this.apiLanguagesLocalesGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetLocalesResult>): GetLocalesResult => r.body)
    );
  }

  /** Path part for operation `apiLanguagesLanguageLocalesGet()` */
  static readonly ApiLanguagesLanguageLocalesGetPath = '/api/Languages/language-locales';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLanguagesLanguageLocalesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLanguagesLanguageLocalesGet$Response(params?: ApiLanguagesLanguageLocalesGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetLanguageLocalesResult>> {
    const obs = apiLanguagesLanguageLocalesGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLanguagesLanguageLocalesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLanguagesLanguageLocalesGet(params?: ApiLanguagesLanguageLocalesGet$Params, context?: HttpContext): Observable<GetLanguageLocalesResult> {
    const resp = this.apiLanguagesLanguageLocalesGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetLanguageLocalesResult>): GetLanguageLocalesResult => r.body)
    );
  }

  /** Path part for operation `apiLanguagesLanguageLocalesIdGet()` */
  static readonly ApiLanguagesLanguageLocalesIdGetPath = '/api/Languages/language-locales/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiLanguagesLanguageLocalesIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLanguagesLanguageLocalesIdGet$Response(params: ApiLanguagesLanguageLocalesIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<LanguageLocaleDto>> {
    const obs = apiLanguagesLanguageLocalesIdGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiLanguagesLanguageLocalesIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiLanguagesLanguageLocalesIdGet(params: ApiLanguagesLanguageLocalesIdGet$Params, context?: HttpContext): Observable<LanguageLocaleDto> {
    const resp = this.apiLanguagesLanguageLocalesIdGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<LanguageLocaleDto>): LanguageLocaleDto => r.body)
    );
  }

}
